import SettingsWrapper from './SettingsWrapper'

export default SettingsWrapper
